var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "h-full" }, [
    _c(
      "section",
      { staticClass: "w-full h-full" },
      [
        _vm._m(0),
        _c("LocationCollectionFilters", {
          attrs: {
            currentUserId: _vm.currentUser.id,
            hideManagersFilter: _vm.isManager,
            filters: _vm.directoryFilters,
          },
          on: {
            filtersChanged: _vm.filterContractorsByOptions,
            resetFilters: _vm.resetFilters,
          },
        }),
        _c(
          "DefaultContentLayoutTalentMapping",
          {
            attrs: {
              leftClasses: "b-talentMapping_left",
              rightClasses: "b-talentMapping_right",
              containerClasses: "b-talentMapping_container",
            },
            scopedSlots: _vm._u([
              {
                key: "left-side",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "h-full flex flex-col" },
                      [
                        _c(
                          "div",
                          { staticClass: "w-full px-4 pb-4" },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  title: "Available",
                                  parentClass: "b-mapping_radio_group",
                                  titleClass: "mb-2",
                                },
                              },
                              [
                                _c("RadioButtonGroup", {
                                  attrs: {
                                    options: _vm.radioOptions,
                                    parentClass: "b-mapping_radio_classes",
                                  },
                                  model: {
                                    value: _vm.available,
                                    callback: function ($$v) {
                                      _vm.available = $$v
                                    },
                                    expression: "available",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "text-sm pt-4 font-normal" },
                              [
                                _vm._v(
                                  _vm._s(_vm.contractorsAndPositions.length) +
                                    " Resources Found"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "ScrollableContainer",
                          {
                            staticClass:
                              "items-center b-left_items_wrapper px-1",
                            scopedSlots: _vm._u(
                              [
                                _vm.loading
                                  ? {
                                      key: "loading",
                                      fn: function () {
                                        return [_c("Spinner")]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                          },
                          _vm._l(
                            _vm.contractorsAndPositions,
                            function (con, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c(
                                    "ContractorLocationCardToLoop",
                                    {
                                      staticClass: "item",
                                      staticStyle: { overflow: "hidden" },
                                      attrs: {
                                        user: con.contractors.user,
                                        jobTitle: con.contractors.user.profile
                                          .job_title
                                          ? con.contractors.user.profile
                                              .job_title
                                          : con.contractors.user.experiences[0]
                                              ?.job_title,
                                        companyName: con.contractors.user
                                          .profile.company_name
                                          ? con.contractors.user
                                              .user_profile_by_managements
                                              .company_name
                                          : con.contractors.user
                                              .user_profile_by_managements
                                              .company_name,
                                        country:
                                          con.contractors.user.profile
                                            ?.country === null
                                            ? con.locationProfile?.country
                                            : con.contractors.user.profile
                                                ?.country,
                                        city:
                                          con.contractors.user.profile.city ===
                                          null
                                            ? con.locationProfile.city
                                            : con.contractors.user.profile.city,
                                        ratingCount:
                                          con.contractors.ratingTotal.aggregate
                                            .sum.score,
                                        ratingUnit: con.rate_unit,
                                        ratingTotal:
                                          con.contractors.ratingTotal,
                                        employeePageRouteParams:
                                          _vm.contractorPageRoute(
                                            con.contractors.id
                                          ),
                                        maxmin: con.maxmin,
                                        skill: con.contractors.user.profile
                                          .skills
                                          ? con.contractors.user.profile.skills
                                          : [],
                                        employeeUserId: con.contractors.user.id,
                                        currentUserId: _vm.currentUser.id,
                                        favoritedByUsers:
                                          con.contractors.user
                                            .favorited_by_users,
                                        items: index,
                                        firstSkill: _vm.getFirstSkill(con),
                                        secondSkill: _vm.getSecondSkill(con),
                                      },
                                      on: {
                                        cardDataUpdated: function ($event) {
                                          return _vm.onUpdateCardList(
                                            $event,
                                            con,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(con) + _vm._s(index) + " "
                                      ),
                                      _c("div", [
                                        _c("br"),
                                        _c("br"),
                                        _c("br"),
                                        _c("br"),
                                        _c("br"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c(
              "LoadingOverlay",
              {
                attrs: {
                  hasData: _vm.hasData,
                  loading: _vm.loading,
                  spinnerCentered: "",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "bg-blue-500 overflow-hidden rounded-tr-2xl rounded-br-2xl",
                  },
                  [
                    _c(
                      "gmap-map",
                      {
                        style: { height: _vm.mapHeight },
                        attrs: {
                          options: {
                            mapTypeControl: false,
                            minZoom: 3,
                          },
                          center: _vm.center,
                          zoom: _vm.zoom,
                          styles: _vm.mapStyles,
                        },
                      },
                      [
                        _vm._l(
                          _vm.contractorsAndPositions,
                          function (marker, index) {
                            return _c("gmap-marker", {
                              key: index,
                              attrs: { position: marker.position },
                              on: {
                                mouseover: function ($event) {
                                  return _vm.handleMarkerMouseOver(marker)
                                },
                                click: function ($event) {
                                  _vm.isZoomed
                                    ? _vm.handleMarkerClick(
                                        marker,
                                        marker.position
                                      )
                                    : _vm.filterContractorByCountry(marker)
                                },
                              },
                            })
                          }
                        ),
                        _vm.isPopupOpen
                          ? _c(
                              "gmap-info-window",
                              {
                                attrs: {
                                  position: _vm.selectedMarker.position,
                                },
                                on: { closeclick: _vm.closePopup },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: { padding: "0", margin: "0" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "b-info-window-content" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-xs font-bold",
                                            staticStyle: { color: "white" },
                                          },
                                          [
                                            _vm._v(
                                              "   " + _vm._s(_vm.countryName)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-xs",
                                            staticStyle: { color: "white" },
                                          },
                                          [
                                            _vm._v(
                                              "  ( " +
                                                _vm._s(
                                                  _vm.numberOfContractors
                                                ) +
                                                " )"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "overflow-y": "auto",
                                          "overflow-x": "hidden",
                                          width: "310px",
                                          height: "270px",
                                          "padding-top": "3px",
                                          "padding-right": "5px",
                                          "padding-left": "5px",
                                        },
                                      },
                                      _vm._l(
                                        _vm.markerFilteredContractors,
                                        function (con, index) {
                                          return _c(
                                            "div",
                                            { key: index },
                                            [
                                              _c(
                                                "ContractorLocationCardToLoop",
                                                {
                                                  staticClass: "item",
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                  },
                                                  attrs: {
                                                    user: con.contractors.user,
                                                    contractor: con.contractors,
                                                    jobTitle: con.contractors
                                                      .user.profile.job_title
                                                      ? con.contractors.user
                                                          .profile.job_title
                                                      : con.contractors.user
                                                          .experiences[0]
                                                          ?.job_title,
                                                    companyName: con.contractors
                                                      .user.profile.company_name
                                                      ? con.contractors.user
                                                          .user_profile_by_managements
                                                          .company_name
                                                      : con.contractors.user
                                                          .user_profile_by_managements
                                                          .company_name,
                                                    maxmin: con.maxmin,
                                                    country: _vm.countryName,
                                                    skill: con.contractors.user
                                                      .profile.skills
                                                      ? con.contractors.user
                                                          .profile.skills
                                                      : [],
                                                    city:
                                                      con.contractors.user
                                                        .profile.city === null
                                                        ? con.locationProfile
                                                            .city
                                                        : con.contractors.user
                                                            .profile.city,
                                                    ratingCount:
                                                      con.contractors
                                                        .ratingTotal.aggregate
                                                        .sum.score,
                                                    ratingTotal:
                                                      con.contractors
                                                        .ratingTotal,
                                                    employeePageRouteParams:
                                                      _vm.contractorPageRoute(
                                                        con.contractors.id
                                                      ),
                                                    employeeUserId:
                                                      con.contractors.user.id,
                                                    currentUserId:
                                                      _vm.currentUser.id,
                                                    favoritedByUsers:
                                                      con.contractors.user
                                                        .favorited_by_users,
                                                    items: index,
                                                    firstSkill:
                                                      _vm.getFirstSkill(con),
                                                    secondSkill:
                                                      _vm.getSecondSkill(con),
                                                  },
                                                  on: {
                                                    cardDataUpdated: function (
                                                      $event
                                                    ) {
                                                      return _vm.onUpdateCard(
                                                        $event,
                                                        con,
                                                        index
                                                      )
                                                    },
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "flex flex-row justify-between h-12 mt-2.5 mb-6" },
      [
        _c("p", { staticClass: "font-semibold w-max-content custom-title" }, [
          _vm._v(" Talent Mapping "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }